export default defineNuxtPlugin(() => {
  window.addEventListener("cookieyes_banner_load", function (eventData: any) {
    const isAnalyticConsent = !!eventData.detail.categories.analytics;
    setPersistence(isAnalyticConsent);
  });

  window.addEventListener("cookieyes_consent_update", function (eventData: any) {
    const isAnalyticConsent = !!eventData.detail.accepted.includes("analytics");
    setPersistence(isAnalyticConsent);
  });
});

function setPersistence(isAnalyticConsent: boolean) {
  const { $posthog } = useNuxtApp();
  $posthog()?.set_config({ persistence: (isAnalyticConsent) ? 'localStorage+cookie' : 'memory' });
}
